import ApiService from "@/common/api.service";

const PATH = (dealId) => `deals/${dealId}/customer-requests`;

export const GET_DEAL_CUSTOMER_REQUESTS = "getDealCustomerRequests";
export const CREATE_DEAL_CUSTOMER_REQUEST = "createDealCustomerRequest";
export const UPDATE_DEAL_CUSTOMER_REQUEST = "updateDealCustomerRequest";
export const DELETE_DEAL_CUSTOMER_REQUEST = "deleteDealCustomerRequest";
export const TRANSITION_DEAL_CUSTOMER_REQUEST = "transitionDealCustomerRequest";
export const MATCH_DEAL_CUSTOMER_REQUEST_PRODUCTS = "matchDealCustomerRequestProducts";

const actions = {
  [GET_DEAL_CUSTOMER_REQUESTS](context, dealId) {
    return ApiService.get(PATH(dealId)).then(({ data }) => data.data || data);
  },

  [CREATE_DEAL_CUSTOMER_REQUEST](context, payload) {
    return ApiService.post(PATH(payload.dealId), payload.params).then(({ data }) => data.data || data);
  },

  [UPDATE_DEAL_CUSTOMER_REQUEST](context, payload) {
    return ApiService.put(`${PATH(payload.dealId)}/${payload.id}`, payload.params).then(
      ({ data }) => data.data || data
    );
  },

  [DELETE_DEAL_CUSTOMER_REQUEST](context, payload) {
    return ApiService.delete(`${PATH(payload.dealId)}/${payload.id}`);
  },

  [TRANSITION_DEAL_CUSTOMER_REQUEST](context, payload) {
    return ApiService.post(`${PATH(payload.dealId)}/${payload.id}/transition`, payload.params).then(
      ({ data }) => data.data || data
    );
  },

  [MATCH_DEAL_CUSTOMER_REQUEST_PRODUCTS](context, payload) {
    return ApiService.query(`${PATH(payload.dealId)}/match-products`, payload.params || {}).then(
      ({ data }) => data.data || data
    );
  },
};

export default {
  actions,
};
